import styled from "styled-components";
import { body3Regular } from "../typography/MuiTypography.style";
import { COLORS, THEME } from "../../styles/constants.style";

export const ChipWrapper = styled.div`
  padding: 10px 0;

  .MuiStack-root {
    flex-wrap: wrap;
    gap: 10px;
  }

  .popover-stack {
    padding: 0px 12px;
  }

  .MuiChip-root {
    margin-left: 0;
    height: 32px;
    padding: 8px 0px;
    background: ${COLORS.cirrus_black2};
    border-radius: 4px;
    border: 1px solid ${COLORS.cirrus_black4};

    .MuiChip-label {
      padding: 0 16px;
      color: ${COLORS.cirrus_black};
      ${body3Regular}
      display: flex;
      flex-direction: row;
      svg {
        width: 16px;
        height: 16px;
      }
    }
    .label {
      max-width: 250px;
    }

    .MuiChip-deleteIcon {
      margin-left: 0px;
      margin-right: 10px;
      width: 12px;
      height: 12px;
    }
  }

  .more-text {
    span {
      color: ${COLORS.primary_light_blue} !important;
      font-weight: ${THEME.fontWeights["semiBold"]} !important;
    }
  }

  .view-only-chip {
    cursor: default;
  }

  .view-only-chip:hover {
    background-color: ${COLORS.cirrus_black2};
  }

  .close-image {
    color: ${COLORS.primary_light_blue};
  }
`;
